<template lang="pug">
#Verification.verification.inside-padding
  form(@submit.prevent="" autocomplete="off")
    h2.title Verificación
    .form-section
      .input-container(v-show='!dni')
        input.input(v-model="dataForm.dni" type="number" min="0" pattern="[0-9]"  :title="warnings.dni" :required="!dni" autocomplete="ño")
        label.label(:class="{ show: dataForm.dni }") Cédula
      .input-container
        input.input(v-model="dataForm.code" type="number" min="100000" max="999999" pattern="[0-9]"  :title="warnings.verification"  autocomplete="ño" required)
        label.label(:class="{ show: dataForm.code }") Código

    shActionButton(:isForm="true" text="Entrar" textRunning="Entrando" :action="login")
</template>

<script>
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlLogin from '@/graphql/login'
import gql from '@my/graphql'
import router from '@my/router'

export default {
  name: 'Verification',

  mixins: [mForm],

  data () {
    return {
      dataForm: {
        dni: '',
        code: ''
      }
    }
  },

  methods: {
    async login () {
      const dni = this.dni ? this.dni : this.dataForm.dni
      const code = this.dataForm.code

      const variables = { dni, code }
      const response = await gql.query(gqlLogin.LOGIN, variables)

      if (response) {
        const token = response.data.login

        this.$store.commit('login', token)
        this.$store.commit('getVariablesApp')
        this.$store.commit('connectSocket')
        modals.showMessage({ message: 'Te has logueado correctamente' })

        this.initForm()

        router.goToHome()
      }
    },

    allowOneType (e, index) {
      const target = e.target
      const next = target.nextElementSibling

      this.dataForm.code[index] = e.key
      target.value = e.key

      if (next) {
        next.focus()
      } else {
        target.blur()
      }
    }
  },

  computed: {
    dni () {
      return this.$store.state.user.dni
    }
  }
}
</script>

<style lang="stylus">
.verification
  position relative
  padding-bottom 1em

.input-container-code
  display flex
  width 100%
  flex-wrap wrap

.input-container-code > .input
  width 2.8em
  margin-right .5em
  font-weight 600
</style>



// WEBPACK FOOTER //
// src/components/pages/login/Verification.vue